import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as EssentialsActions from './essentials.actions';
import { EssentialsState } from '@core/interfaces/essentials';
import { tap, switchMap, take, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { EssentialsService, mapEssentialToCard } from '@core/services/essentials/essentials.service';

@Injectable()
export class EssentialsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<EssentialsState>,
    private readonly _essentialService: EssentialsService,
  ) {}

  readonly loadEssentials$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EssentialsActions.loadEssentials),
      switchMap(({ code, sector, zone, schema, segment, group, limit }) => {
        const body = { code, sector, zone, schema, segment };
        const request$ = group && limit
          ? this._essentialService.getEssentialsByGroup({ ...body, group, limit })
          : this._essentialService.getEssentials(body);
   // Limpiar sessionStorage y el store antes de cargar nuevos datos
   sessionStorage.removeItem('essentials'); // Eliminar los essentials de sessionStorage
   sessionStorage.removeItem('essentials_loading'); // Eliminar loading
   sessionStorage.removeItem('essentials_error'); // Eliminar error

   // Limpiar el store de essentials
   this.store.dispatch(EssentialsActions.clearEssentials()); // Limpiar los essentials en el store
        // Despachar la acción para poner loading a true (solo activamos la acción de loading)
        this.store.dispatch(EssentialsActions.essentialsLoading({ loading: true }));
  
        return request$.pipe(
          take(1),
          map((res: any) => {
            if (res && Array.isArray(res)) {
              const productCards = res.map(mapEssentialToCard);
  
              // Guardar los essentials en sessionStorage
              sessionStorage.setItem('essentials', JSON.stringify(productCards));
              sessionStorage.setItem('essentials_loading', JSON.stringify(false));  // Persistir loading como false
              sessionStorage.setItem('essentials_error', JSON.stringify(false)); // Persistir error como false
  
              return EssentialsActions.setEssentials({ essentials: productCards });
            }
            return EssentialsActions.setEssentials({ essentials: [] });
          }),
          catchError(() => {
            sessionStorage.setItem('essentials_error', JSON.stringify(true)); // Persistir error
            return of(EssentialsActions.essentialsError({ error: true }));
          })
        );
      })
    )
  );
  

  // Persistir el estado de error en sessionStorage
  readonly persistErrorState$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EssentialsActions.essentialsError),
        tap(() => {
          sessionStorage.setItem('essentials_error', JSON.stringify(true));  // Persistir error
        })
      ),
    { dispatch: false }
  );
}
